import { Formik } from 'formik'
import * as React from 'react'
import { connect } from 'react-redux'

import { handleApiCall } from '../../common/api'
import { makeGoToUrl } from '../../common/router'
import { config } from '../../form-record'
import { CAPATCHA } from '../../form-record/fields'
import {
  buildGoogleCalendarLink,
  buildInitialValues,
  buildValidationSchema,
  Container,
  ErrorAlert,
  Field,
  Footer,
  getKey,
  Header,
  isLimitReached,
  LimitedSuccessView,
  LimitedView,
  LoadingMask,
  MainContent,
  Page,
  parseEnd,
  parseStart,
  SubmitButton,
  SuccessView,
} from '../../form-record/public-view'
import { Capatcha } from '../../form-record/public-view/fields/Capatcha'
import { RodoInfo } from '../../form-record/public-view/ui/RodoInfo'
import { FormRecord } from '../../form-record/types'
import { formikErrorsToArr } from '../../form-record/utils'
import { withPublicFormRecord } from '../../form-record/withPublicFormRecord'
import { RootState } from '../../redux/store'

const footerText =
  'Portal współfinansowany przez Unię Europejską ze środków Europejskiego Funduszu Rozwoju Regionalnego w ramach RPO WL na lata 2007-2013 oraz z Europejskiego Funduszu Społecznego w ramach RPO WL na lata 2014-2020'
const footerImage = require('../../images/logotypes.png')

interface State {
  wasSubmitted: boolean
  successModalVisible: boolean
  limitedModalVisible: boolean
  limitedSuccessModalVisible: boolean
  isSubmiting: boolean
}
class PageView extends React.Component<
  {
    goToUrl: (url: string) => void
    formRecord: FormRecord
    recapatchaPublicKey: string
  },
  State
> {
  state: State = {
    wasSubmitted: false,
    successModalVisible: false,
    limitedModalVisible: false,
    limitedSuccessModalVisible: false,
    isSubmiting: false,
  }
  recaptchaInstance: Capatcha | null
  form: HTMLFormElement | null
  onCloseSuccessView = () => {
    this.setState({
      successModalVisible: false,
      wasSubmitted: false,
    })
  }
  onCloseLimitedView = () => {
    this.setState({
      limitedModalVisible: false,
      wasSubmitted: false,
    })
  }
  onCloseLimitedSuccessView = () => {
    this.setState({
      limitedModalVisible: true,
      limitedSuccessModalVisible: false,
      wasSubmitted: false,
    })
  }
  handleLimitedSubmit = (values, bag) => {
    // TODO wysylac powiaoomienie do admina, nie zapisywać maila w bazie
    const { formRecord } = this.props
    bag.setSubmitting(true)
    this.setState({ wasSubmitted: false })
    handleApiCall({
      method: 'POST',
      url: config.api.urls.submitLimitedForm(formRecord.id),
      values: values,
      bag,
      onSuccess: res => {
        bag.setSubmitting(false)
        window.scroll(0, 0)
        // reset form
        bag.resetForm()

        this.setState({ limitedSuccessModalVisible: true })
      },
      onError: err => {
        window.scroll(0, 0)
        if (isLimitReached(err)) {
          // TODO show ask for email form
        } else {
          bag.setSubmitting(false)
        }
      },
    })
  }
  onSubmit = (values: {}, bag: any) => {
    const { formRecord } = this.props
    //  Todo transform multiple checkboxes
    const formData = new FormData()
    formRecord.formSpec.fields.map((el, i) => {
      const key = getKey(i)
      if (values.hasOwnProperty(key)) {
        if (!!el.multiple) {
          if (Array.isArray(values[key])) {
            values[key].map(el => {
              formData.append(key + '[]', el)
            })
          } else {
            console.error(key, ' to powinno być tablicą')
          }
        } else {
          formData.append(key, values[key])
        }
      }
    })
    // for (const f in values) {
    //   if (values.hasOwnProperty(f)) {
    //     formData.append(f, values[f])
    //   }
    // }

    const axiosConfig = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }
    bag.setSubmitting(true)
    this.setState({ wasSubmitted: false, isSubmiting: true })
    handleApiCall({
      method: 'POST',
      url: config.api.urls.submitForm(formRecord.id),
      values: formData,
      bag,
      config: axiosConfig,
      onSuccess: res => {
        bag.setSubmitting(false)
        this.setState({ wasSubmitted: true, isSubmiting: false })
        window.scroll(0, 0)
        this.resetCapatcha()
        // reset form
        bag.resetForm()
        this.form && this.form.reset()

        this.setState({ successModalVisible: true })
      },
      onError: err => {
        window.scroll(0, 0)
        if (isLimitReached(err)) {
          // TODO show ask for email form
          this.setState({ limitedModalVisible: true, isSubmiting: false })
        } else {
          this.resetCapatcha()
          bag.setSubmitting(false)
          this.setState({ wasSubmitted: true, isSubmiting: false })
        }
      },
    })
  }
  resetCapatcha = () => {
    this.recaptchaInstance &&
      this.recaptchaInstance.recaptchaInstance &&
      this.recaptchaInstance.recaptchaInstance.reset()
  }
  componentDidMount() {
    // TODO jesli formRecord.limited && limit reached to pokaz odrazu limitedView
    const { formRecord } = this.props
    // zmienmy tytul strony
    document.title =
      formRecord.title +
      ' - ' +
      'Regionalny Program Operacyjny na lata 2014-2020 - Województwo Lubelskie'
    if (
      formRecord.isLimited &&
      formRecord.limitedTo &&
      formRecord.limitedTo <= formRecord.sendFormsCount
    ) {
      this.setState({ limitedModalVisible: true })
    }
  }

  render() {
    const { formRecord, recapatchaPublicKey } = this.props
    const {
      wasSubmitted,
      successModalVisible,
      limitedModalVisible,
      limitedSuccessModalVisible,
      isSubmiting,
    } = this.state
    let initialValues = buildInitialValues(formRecord)
    const validationSchema = buildValidationSchema(formRecord)

    const start = parseStart(formRecord)
    const end = parseEnd(formRecord)

    const addToCalendarUrl = buildGoogleCalendarLink(
      formRecord.title,
      start,
      end,
      formRecord.shortBody,
      formRecord.place,
    )
    return (
      <>
        <LoadingMask isVisible={isSubmiting} title="Chwileczkę..." />
        <Page>
          <Header
            goBackUrl={formRecord.goBackUrl}
            formRecord={formRecord}
            addToCalendarUrl={addToCalendarUrl}
          />
          <Container>
            <MainContent>
              {!successModalVisible &&
                !limitedModalVisible &&
                !limitedSuccessModalVisible && (
                  <Formik
                    onSubmit={this.onSubmit}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    render={({
                      handleSubmit,
                      setFieldValue,
                      setFieldTouched,
                      values,
                      isSubmitting,
                      errors,
                      touched,
                    }) => {
                      const fields = formRecord.formSpec.fields

                      return (
                        <form
                          ref={e => {
                            this.form = e
                          }}
                          onSubmit={e => {
                            e.preventDefault()
                            window.scroll(0, 0)
                            this.setState({
                              wasSubmitted: true,
                            })
                            handleSubmit()
                          }}
                        >
                          <RodoInfo
                            url="https://rpo.lubelskie.pl/klauzula-informacyjna-polityka-cookies/"
                            title="Klauzula informacyjna dotycząca przetwarzania Twoich danych"
                          />
                          {wasSubmitted && (
                            <ErrorAlert
                              errors={formikErrorsToArr(errors, fields)}
                            />
                          )}
                          {fields.map((field, i) => {
                            const key = getKey(i)
                            const hasError = !!(
                              errors[key] &&
                              touched[key] &&
                              (touched[key] === true ||
                                Array.isArray(touched[key]))
                            )

                            return (
                              <Field
                                field={field}
                                id={key}
                                key={key}
                                hasError={hasError}
                                error={String(errors[key])}
                                value={values[key]}
                                onChange={(
                                  value: string | number | string[] | File,
                                ) => {
                                  setFieldValue(key, value)
                                }}
                                recapatchaPublicKey={
                                  field.type === CAPATCHA
                                    ? recapatchaPublicKey
                                    : undefined
                                }
                                onBlur={() => {
                                  setFieldTouched(key, true)
                                }}
                                ref={e => {
                                  // console.log(e)
                                  if (e && e['recaptchaInstance']) {
                                    this.recaptchaInstance =
                                      e['recaptchaInstance']
                                  }
                                }}
                              />
                            )
                          })}

                          <SubmitButton
                            disabled={isSubmitting}
                            text={'Wyślij formularz'}
                          />
                        </form>
                      )
                    }}
                  />
                )}
              {successModalVisible && (
                <SuccessView
                  title="Formularz został poprawnie wysłany"
                  message={formRecord.successMessage}
                  goBackUrl={formRecord.goBackUrl}
                  onClose={this.onCloseSuccessView}
                />
              )}
              {limitedModalVisible && !limitedSuccessModalVisible && (
                <LimitedView
                  title="Przepraszamy. Brak wolnych miejsc"
                  message={formRecord.limitedMessage || ''}
                  onGoBackToForm={() => this.onCloseLimitedView}
                  onSubmit={this.handleLimitedSubmit}
                  goBackUrl={formRecord.goBackUrl}
                  limitedUrl={formRecord.limitedUrl}
                  limitedBtnLabel={formRecord.limitedBtnLabel}
                />
              )}
              {limitedSuccessModalVisible && (
                <LimitedSuccessView
                  title="Dziękujemy"
                  message={'Powiadomimy Cię gdy będą wolne miejsca'}
                  onClose={this.onCloseLimitedSuccessView}
                  goBackUrl={formRecord.goBackUrl}
                />
              )}
            </MainContent>
          </Container>
          <Footer text={footerText} image={footerImage} />
        </Page>
      </>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  goToUrl(url: string) {
    makeGoToUrl(dispatch)(url)
  },
})
const mapStateToProps = (state: RootState) => ({
  recapatchaPublicKey: (window as any).RECAPATCHA_PUBLIC_KEY || '',
})
export default withPublicFormRecord(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(PageView),
)
